var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfo = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0Z",
    fill: "#1A1A2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.449 4.106v-.942H5.47v.942h.979Zm1.383 4.73v-.573H6.344V4.86H4.33v.565h1.318v2.837h-1.48v.573h3.664Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.302 3h1.315v1.27H5.302V3Zm.337.327v.616h.641v-.616H5.64Zm-1.477 1.37h2.35V8.1H8V9H4v-.9h1.48V5.59H4.162v-.893Zm.337.327v.239h1.318v3.163h-1.48v.247h3.326v-.247H6.175V5.024H4.5Z",
    fill: "#fff"
  })));
};
export default SvgInfo;